import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)

// 配置vue-devtools
if (process.env.NODE_ENV === 'development') {
    // 确保在开发环境中启用devtools
    app.config.devtools = true
}

app.mount('#app')
